import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ErrorState {
  message: string | null;
  timestamp: number;
}

const initialState: ErrorState = {
  message: null,
  timestamp: 0,
};

export const errorSlice = createSlice({
  name: 'error',
  initialState,
  reducers: {
    showError: (state, action: PayloadAction<string>) => {
      state.message = action.payload;
      state.timestamp = Date.now();
    },
    clearError: (state) => {
      state.message = null;
    },
  },
});

export const { showError, clearError } = errorSlice.actions;
export default errorSlice.reducer;
